import { SupportedChainId } from 'config/chains'
import { XKDK_ADDRESSES } from 'constants/addresses'
import { unsupportedSwapTokens } from 'constants/unsupportedSwapTokens'
import { useConnection } from 'hooks/useConnection'
import { useCurrencyBalances } from 'state/connection/hooks'
import styled from 'styled-components'

import { useAllTokens } from '../../hooks/Tokens'
import { useModalIsOpen, useToggleWalletModal } from '../../state/application/hooks'
import { ApplicationModal } from '../../state/application/reducer'
import AccountDetails from '../AccountDetails'
import Modal from '../Modal'

const Wrapper = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  margin: 0;
  padding: 0;
  width: 100%;
`

export default function WalletModal({
  pendingTransactions,
  confirmedTransactions,
}: {
  pendingTransactions: string[] // hashes of pending
  confirmedTransactions: string[] // hashes of confirmed
}) {
  const { account, chainId } = useConnection()

  const walletModalOpen = useModalIsOpen(ApplicationModal.WALLET)
  const toggleWalletModal = useToggleWalletModal()

  const xkdkAddress = XKDK_ADDRESSES[chainId as SupportedChainId]
  const allTokens = useAllTokens([...unsupportedSwapTokens, ...(xkdkAddress ? [xkdkAddress] : [])])
  const allTokensArray = Object.values(allTokens)

  const balances = useCurrencyBalances(walletModalOpen ? account : undefined, allTokensArray)

  return (
    <Modal isOpen={walletModalOpen} onDismiss={toggleWalletModal} minHeight={false} maxHeight={90} withoutAnimation>
      <Wrapper>
        {account ? (
          <AccountDetails
            pendingTransactions={pendingTransactions}
            confirmedTransactions={confirmedTransactions}
            tokens={allTokensArray}
            balances={balances}
          />
        ) : null}
      </Wrapper>
    </Modal>
  )
}
